import PortfolioBuildBlog from "./PortfolioBuildBlog";

export const blogs = {
  "PortfolioBuildBlog": {
    title: "Portfolio Build Blog",
    description: "tldr: Rebuilt my portfolio using React, GitHub Actions, and a separate consistent repository. Now publishing articles or updating projects is automated & maintainable.",
    tags: ["portfolio","personal projects","react"],
    component: PortfolioBuildBlog,
  },
};